RivalIQ.apps.Admin.apps.Company.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.PrimaryHandleDeleteModal = Marionette.ItemView.extend({
        template: '#adminCompanyPrimaryHandleDeleteModalTemplate',

        ui: {
            deleteBtn: '.x-delete'
        },

        events: {
            'click @ui.deleteBtn': 'deleteHandle'
        },

        deleteHandle: function () {
            const me = this;
            me.model.trigger('destroy', me.model, me.model.collection);
        }
    });
});
